var React = require('react');

function CommunityHall (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"5.8","y":"89.5","width":"86","height":"7.4","key":0}),React.createElement("path",{"d":"M10.3,87H41V71.7c0-4.3,3.5-7.8,7.8-7.8s7.8,3.5,7.8,7.8V87h30.6V40.2h2.3v-7.3H62.2v-5.5L50.1,10.2v-3H57V1.7h-8.5v2.2v3.2\n\tv3.1l-12,17.2v5.5H8v7.3h2.3V87z M69.5,46.3h6.2v7.6h-6.2V46.3z M69.5,60h6.2v7.6h-6.2V60z M69.5,73.7h6.2v7.6h-6.2V73.7z\n\t M45.5,39.7c1.8-1.8,4.7-1.8,6.5,0s1.8,4.7,0,6.5s-4.7,1.8-6.5,0C43.7,44.5,43.7,41.5,45.5,39.7z M21.9,46.3h6.2v7.6h-6.2\n\tC21.9,53.9,21.9,46.3,21.9,46.3z M21.9,60h6.2v7.6h-6.2C21.9,67.6,21.9,60,21.9,60z M21.9,73.7h6.2v7.6h-6.2\n\tC21.9,81.3,21.9,73.7,21.9,73.7z","key":1})]);
}

CommunityHall.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 100 101.7","style":{"enableBackground":"new 0 0 100 101.7"},"xmlSpace":"preserve"};

module.exports = CommunityHall;

CommunityHall.default = CommunityHall;
